import { render, staticRenderFns } from "./CatalogSongResults.vue?vue&type=template&id=74222866&scoped=true"
import script from "./CatalogSongResults.vue?vue&type=script&lang=ts"
export * from "./CatalogSongResults.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSongResults.vue?vue&type=style&index=0&id=74222866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74222866",
  null
  
)

export default component.exports